import { forwardRef, useImperativeHandle } from 'react';
import ExcelJS from 'exceljs';
import CargoManagementCommand from '../../../../services/command/cargoManagement/CargoManagementCommand.services';
import { Shipment } from '../../MPPrepareReturnToSellerList.config';
import TimeHelper from '../../../../utils/time';
import { MPRTS } from '../../mpPrepareReturnToSellerList.classes';

export const DowmloadExcelMPPrepareReturnShipment = forwardRef((props: any, ref: any) => {
    useImperativeHandle(ref, () => ({
        printSomething: downloadExcel,
    }));

    const downloadExcel = async (sendMail?: boolean) => {
        if (props.data && props.data.length > 0) {
            const selectedData = props.data.map(
                ({
                    shippingListNo,
                    orderNumber,
                    cargoShipmentCode,
                    orderDate,
                    sellerName,
                    shippingCompanyName,
                }: Shipment) => [
                    shippingListNo,
                    orderNumber,
                    cargoShipmentCode,
                    TimeHelper.formatDateHour(orderDate),
                    sellerName,
                    shippingCompanyName,
                ]
            );

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('MPReturn');

            // Header row (merged)
            worksheet.mergeCells('A1:F1');
            worksheet.getCell('A1').value =
                '                                       İNTERNET DEPO KARGO TESLİM FORMU: ' +
                new Date().toJSON().slice(0, 10).replace(/-/g, '/');
            worksheet.getRow(1).height = 30;

            // Empty row
            worksheet.addRow([]);

            // Column headers
            worksheet.addRow([
                'Sevkiyat No',
                'Sipariş No',
                'Müşteri İade Kodu',
                'Sipariş Tarihi',
                'Satıcı',
                'Kargo Firması',
            ]);

            // Data rows
            selectedData.forEach((row: any) => worksheet.addRow(row));

            // Summary and signature rows
            worksheet.addRow(['Toplam Sipariş Sayısı', props.data.length]);
            worksheet.addRow([' ', '']);
            worksheet.addRow(['İmza', '']);
            worksheet.addRow(['Teslim Eden İsim Soy İsim', '']);
            worksheet.addRow(['Açıklama', '']);

            // Set column widths
            worksheet.columns = [
                { width: 25 },
                { width: 15 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 15 },
            ];

            // Set row heights for summary/signature rows
            const baseRow = selectedData.length + 4;
            worksheet.getRow(baseRow).height = 30;
            worksheet.getRow(baseRow + 1).height = 30;
            worksheet.getRow(baseRow + 2).height = 30;
            worksheet.getRow(baseRow + 3).height = 30;

            // Download file
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const fileName = 'MPReturn' + new Date().toJSON().slice(0, 10).replace(/-/g, '_') + '.xlsx';
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();

            // Send as base64 if needed
            if (sendMail) {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = function () {
                    let base64String = reader.result;
                    CargoManagementCommand.SendDeliveryList({
                        Document: base64String,
                        ShippingCompanyId: props.shippingCompanyId,
                    }).then((res: any) => {
                        console.info(res);
                    });
                };
            }
        }
    };
    return <div className={MPRTS.hiddenExcelBridge} style={{ display: 'none' }} aria-hidden />;
});
